export default __webpack_public_path__ + "static/media/mountain.8e77cde8.gif";